// removed by extract-text-webpack-plugin
module.exports = {"listItem":"styles__listItem___1G_na","adSearchResult":"styles__adSearchResult___1xQF5","adLabel":"styles__adLabel___23vPc"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/searchResults/styles.css
// module id = TPfb
// module chunks = 2